export default "__VITE_ASSET__CoZnHY5___"